(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[16],{

/***/ "44E3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return needPuginV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currentOpenloaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return userState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return currentShopState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return snapshootState; });
/* unused harmony export reportState */
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("T1Xd");
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(recoil__WEBPACK_IMPORTED_MODULE_0__);

var userState = Object(recoil__WEBPACK_IMPORTED_MODULE_0__["atom"])({
  key: 'user',
  default: null
});
var currentShopState = Object(recoil__WEBPACK_IMPORTED_MODULE_0__["atom"])({
  key: 'current-shop',
  default: null
});
var snapshootState = Object(recoil__WEBPACK_IMPORTED_MODULE_0__["atom"])({
  key: 'snapshoot-store',
  default: []
});
var reportState = Object(recoil__WEBPACK_IMPORTED_MODULE_0__["atom"])({
  key: 'report-state',
  default: ''
});
var currentOpenloaction = Object(recoil__WEBPACK_IMPORTED_MODULE_0__["atom"])({
  key: 'current-loaction',
  default: ''
});
var needPuginV = Object(recoil__WEBPACK_IMPORTED_MODULE_0__["atom"])({
  key: 'need-pulg-in-version',
  default: ''
});


/***/ }),

/***/ "4ISH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return useMount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return useMedia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useDebounce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return useQueryUrlParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useCurrentShop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useGetCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return useGetProductList; });
/* unused harmony export useGetProductOfTagList */
/* unused harmony export useType */
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ODXe");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rePB");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KQm4");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("20a2");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("cr+I");
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(query_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Dp36");
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("1ZD8");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("0lfv");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("T1Xd");
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(recoil__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _model_user__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("44E3");




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*
 * @Author: yewei
 * @Date: 2021-01-15 14:26:07
 * @Last Modified by: yewei
 * @Last Modified time: 2022-01-13 16:54:43
 *
 * 定义了通用的逻辑
 * - 如果通用逻辑中有用到其它hook，就将其定义为一个hook
 */










var useMount = function useMount(callback) {
  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    callback();
  }, []);
};

var isBrowser = function isBrowser() {
  return true;
};

var useMedia = function useMedia(query) {
  var defaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])(),
      state = _useState[0],
      setState = _useState[1];

  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    var mounted = true;
    var mql = window.matchMedia(query);

    var onChange = function onChange(e) {
      if (!mounted) {
        return;
      }

      setState(!!e.matches);
    };

    (mql === null || mql === void 0 ? void 0 : mql.addEventListener) && (mql === null || mql === void 0 ? void 0 : mql.addEventListener('change', onChange));
    setState(mql.matches);
    return function () {
      mounted = false;
      (mql === null || mql === void 0 ? void 0 : mql.removeEventListener) && (mql === null || mql === void 0 ? void 0 : mql.removeEventListener('change', onChange));
    };
  }, [query]);
  return state;
}; // 防抖

var useDebounce = function useDebounce(fn, delay, options) {
  return Object(react__WEBPACK_IMPORTED_MODULE_3__["useCallback"])(Object(___WEBPACK_IMPORTED_MODULE_8__[/* debounce */ "d"])(fn, delay, options), (options === null || options === void 0 ? void 0 : options.deps) ? Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__["default"])(options === null || options === void 0 ? void 0 : options.deps) : []);
}; // 返回 url 指定的参数名，设置当前路径的参数

var useQueryUrlParams = function useQueryUrlParams(keys, path) {
  var router = Object(next_router__WEBPACK_IMPORTED_MODULE_4__["useRouter"])();

  var setUrlParams = function setUrlParams(params, isOnly) {
    var obj;

    if (isOnly) {
      obj = Object(___WEBPACK_IMPORTED_MODULE_8__[/* cleanObject */ "b"])(_objectSpread({
        page: 1
      }, params));
    } else {
      obj = Object(___WEBPACK_IMPORTED_MODULE_8__[/* cleanObject */ "b"])(_objectSpread(_objectSpread({}, router.query), {}, {
        page: 1
      }, params));
    }

    router.push("".concat(path || '', "?").concat(query_string__WEBPACK_IMPORTED_MODULE_5___default.a.stringify(obj, {
      arrayFormat: 'comma'
    })), undefined, {
      shallow: true
    });
  };

  return [react__WEBPACK_IMPORTED_MODULE_3___default.a.useMemo(function () {
    return keys.reduce(function (prev, key) {
      var obj = prev;

      if (router.query[key]) {
        obj[key] = router.query[key];
      }

      return obj;
    }, {});
  }, [router.query]), setUrlParams];
}; // 获取选择的店铺

var useCurrentShop = function useCurrentShop() {
  // 从地址栏、localStorage 中获取，优先级从高到低取
  var _useRecoilState = Object(recoil__WEBPACK_IMPORTED_MODULE_10__["useRecoilState"])(_model_user__WEBPACK_IMPORTED_MODULE_11__[/* userState */ "e"]),
      _useRecoilState2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useRecoilState, 1),
      user = _useRecoilState2[0];

  var getCurrentShop = function getCurrentShop() {
    var current = localStorage.getItem('currentShop') || '{}';
    var userInfo = JSON.parse(localStorage.getItem('user') || '{}');
    var localShopInfo = JSON.parse(current)[userInfo.id || 0];
    return localShopInfo;
  };

  var setCurrentShop = function setCurrentShop(shop) {
    var current = JSON.parse(localStorage.getItem('currentShop') || '{}');
    current[(user === null || user === void 0 ? void 0 : user.id) || 0] = shop;
    localStorage.setItem('currentShop', JSON.stringify(current));
  };

  return [getCurrentShop, setCurrentShop];
}; // 获取类目

var useGetCategoryList = function useGetCategoryList() {
  return Object(react_query__WEBPACK_IMPORTED_MODULE_7__["useQuery"])(['getCategoryList'], _services_api__WEBPACK_IMPORTED_MODULE_6__[/* getCategoryList */ "vb"]);
};
var useGetProductList = function useGetProductList(_ref) {
  var planId = _ref.planId,
      rangeTime = _ref.rangeTime,
      _ref$processSequence = _ref.processSequence,
      processSequence = _ref$processSequence === void 0 ? 'processPlan' : _ref$processSequence,
      isShowSingle = _ref.isShowSingle,
      tag = _ref.tag,
      rangeTimeLimit = _ref.rangeTimeLimit,
      setRangeTimeLimit = _ref.setRangeTimeLimit,
      setData = _ref.setData;

  function format(time) {
    if (!time) return '';
    return moment__WEBPACK_IMPORTED_MODULE_9___default()(time).format('YYYY-MM-DD 00:00:00');
  }

  return Object(react_query__WEBPACK_IMPORTED_MODULE_7__["useQuery"])(['getProductList', rangeTime, tag, isShowSingle, processSequence, planId], function () {
    return isShowSingle ? Object(_services_api__WEBPACK_IMPORTED_MODULE_6__[/* getProductList */ "uc"])({
      planId: planId,
      processSequence: processSequence,
      startTime: format(rangeTime[0]),
      endTime: rangeTime[1] + ' 23:59:59'
    }) : Object(_services_api__WEBPACK_IMPORTED_MODULE_6__[/* getProductOfTagList */ "wc"])({
      planId: planId,
      processSequence: processSequence,
      startTime: format(rangeTime[0]) || format(rangeTimeLimit[0]),
      endTime: format(rangeTime[1]) || format(rangeTimeLimit[1]),
      tag: tag || ''
    });
  }, {
    keepPreviousData: true,
    onSuccess: function onSuccess(res) {
      // 单项指标/全部指标
      if (isShowSingle) {
        setData && setData(res.data.products);
        setRangeTimeLimit && setRangeTimeLimit([res.data.startTime, res.data.endTime]);
      } else {
        setData && setData(res.data.products.map(function (product) {
          return _objectSpread(_objectSpread({}, product), res.data.timaStrs.map(function (time, timeIndex) {
            return product.detail[timeIndex];
          }));
        }));
      }
    }
  });
};
var useGetProductOfTagList = function useGetProductOfTagList(_ref2) {
  var planId = _ref2.planId,
      rangeTime = _ref2.rangeTime,
      _ref2$processSequence = _ref2.processSequence,
      processSequence = _ref2$processSequence === void 0 ? 'processPlan' : _ref2$processSequence,
      tag = _ref2.tag;
  return Object(react_query__WEBPACK_IMPORTED_MODULE_7__["useQuery"])(['getProductList', rangeTime], function () {
    return Object(_services_api__WEBPACK_IMPORTED_MODULE_6__[/* getProductOfTagList */ "wc"])({
      planId: planId,
      processSequence: processSequence,
      startTime: rangeTime[0],
      endTime: rangeTime[1],
      tag: tag
    });
  }, {
    keepPreviousData: true,
    onSuccess: function onSuccess(res) {}
  });
}; // export const useThrottle = (fn: () => void, delay: number) => {
//   return useCallback(throttle(fn, delay), []);
// };

var useType = function useType(o) {
  var _Object$propertype;

  var s = Object === null || Object === void 0 ? void 0 : (_Object$propertype = Object.propertype) === null || _Object$propertype === void 0 ? void 0 : _Object$propertype.toString.call(o);
  return s === null || s === void 0 ? void 0 : s.match(/object(.∗?)/)[1].toLowerCase();
};

/***/ }),

/***/ "8jRI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher) || [];

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),

/***/ "8yz6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = (string, separator) => {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [string];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [string];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
};


/***/ }),

/***/ "TqRt":
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "ZFOp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);


/***/ }),

/***/ "c0go":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (obj, predicate) {
	var ret = {};
	var keys = Object.keys(obj);
	var isArr = Array.isArray(predicate);

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i];
		var val = obj[key];

		if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
			ret[key] = val;
		}
	}

	return ret;
};


/***/ }),

/***/ "cr+I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

const strictUriEncode = __webpack_require__("ZFOp");
const decodeComponent = __webpack_require__("8jRI");
const splitOnFirst = __webpack_require__("8yz6");
const filterObject = __webpack_require__("c0go");

const isNullOrUndefined = value => value === null || value === undefined;

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index':
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[', index, ']'].join('')];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
				];
			};

		case 'bracket':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[]'].join('')];
				}

				return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
			};

		case 'comma':
		case 'separator':
			return key => (result, value) => {
				if (value === null || value === undefined || value.length === 0) {
					return result;
				}

				if (result.length === 0) {
					return [[encode(key, options), '=', encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};

		default:
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, encode(key, options)];
				}

				return [...result, [encode(key, options), '=', encode(value, options)].join('')];
			};
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index':
			return (key, value, accumulator) => {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return (key, value, accumulator) => {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'comma':
		case 'separator':
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
				accumulator[key] = newValue;
			};

		default:
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function parse(query, options) {
	options = Object.assign({
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const ret = Object.create(null);

	if (typeof query !== 'string') {
		return ret;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return ret;
	}

	for (const param of query.split('&')) {
		if (param === '') {
			continue;
		}

		let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '=');

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : ['comma', 'separator'].includes(options.arrayFormat) ? value : decode(value, options);
		formatter(decode(key, options), value, ret);
	}

	for (const key of Object.keys(ret)) {
		const value = ret[key];
		if (typeof value === 'object' && value !== null) {
			for (const k of Object.keys(value)) {
				value[k] = parseValue(value[k], options);
			}
		} else {
			ret[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return ret;
	}

	return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
		const value = ret[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = (object, options) => {
	if (!object) {
		return '';
	}

	options = Object.assign({
		encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ','
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key])) ||
		(options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const key of Object.keys(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = object[key];
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
};

exports.parseUrl = (url, options) => {
	options = Object.assign({
		decode: true
	}, options);

	const [url_, hash] = splitOnFirst(url, '#');

	return Object.assign(
		{
			url: url_.split('?')[0] || '',
			query: parse(extract(url), options)
		},
		options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
	);
};

exports.stringifyUrl = (object, options) => {
	options = Object.assign({
		encode: true,
		strict: true
	}, options);

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = exports.extract(object.url);
	const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

	const query = Object.assign(parsedQueryFromUrl, object.query);
	let queryString = exports.stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		hash = `#${encode(object.fragmentIdentifier, options)}`;
	}

	return `${url}${queryString}${hash}`;
};

exports.pick = (input, filter, options) => {
	options = Object.assign({
		parseFragmentIdentifier: true
	}, options);

	const {url, query, fragmentIdentifier} = exports.parseUrl(input, options);
	return exports.stringifyUrl({
		url,
		query: filterObject(query, filter),
		fragmentIdentifier
	}, options);
};

exports.exclude = (input, filter, options) => {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return exports.pick(input, exclusionFilter, options);
};


/***/ }),

/***/ "kHIg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ wrapNativeSuper_wrapNativeSuper; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("foSv");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__("s4An");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
var isNativeReflectConstruct = __webpack_require__("2WcH");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/construct.js


function construct_construct(Parent, args, Class) {
  if (Object(isNativeReflectConstruct["a" /* default */])()) {
    construct_construct = Reflect.construct.bind();
  } else {
    construct_construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) Object(setPrototypeOf["a" /* default */])(instance, Class.prototype);
      return instance;
    };
  }
  return construct_construct.apply(null, arguments);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js




function wrapNativeSuper_wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  wrapNativeSuper_wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return construct_construct(Class, arguments, Object(getPrototypeOf["default"])(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return Object(setPrototypeOf["a" /* default */])(Wrapper, Class);
  };
  return wrapNativeSuper_wrapNativeSuper(Class);
}

/***/ })

}]);